import React from 'react'

// components
import InputField from '../../InputField/InputField.component'

import { Grid, Paper, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

export default function PurchaseOrderEquipmentInput({ prefix, name, category, quantity, price, handleChange, handleRemove, errors }) {

    return (<Grid container spacing={4}>
        <Grid item xs={1}>
            <IconButton onClick={handleRemove}>
                <RemoveCircleIcon color='error' />
            </IconButton>
        </Grid>
        <Grid item xs={11}>
            <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                <Grid container sx={{ marginBottom: 4 }}>
                    <Grid item xs={8}><Typography variant="h6">{name}</Typography></Grid>
                    <Grid item xs={4} textAlign={'right'}>{category}</Grid>
                </Grid>

                <Grid container>
                    <Grid item xs={12}>
                        <InputField 
                            id={`${prefix}.quantity`}
                            type="text"
                            placeholder='Quantity'
                            onChange={handleChange}
                            value={quantity}
                            isValid={errors['quantity']}
                        />
                        </Grid>
                    <Grid item xs={12}>
                        <InputField 
                            id={`${prefix}.price`}
                            type="decimal"
                            placeholder='Unit Price'
                            onChange={handleChange}
                            value={price}
                            isValid={errors['price']}
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    </Grid>)
}